import React from 'react';
import { Table, Button, message, Alert, Popconfirm, Icon, Tooltip, Col, Row, Tag, Modal, Divider, Spin, Menu, Dropdown } from 'antd';
import AdvancedForm from './AdvancedForm';
import ModulesAction from './Modules.Action';
// import { tree } from 'kts-platform-frame/utils';
import UIEmail from './UI.EmailList';
import UIEmailSet from './UI.Email.Set';
import RetryForm from './ReTryForm';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { connect } from 'kts-platform-frame/redux';
import InfiniteScroll from 'react-infinite-scroller';
import SwitchGroup from './UI.SwitchGroup';
import { invoiceInput } from 'src/api';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import { typeDescNew } from 'kts-platform-frame/entry/constant/InvoiceType/EnumInvoiceType';
import Template from 'kts-platform-frame/display/components/InvoiceTemplate';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import InvoiceDetail from './UI.InvoiceDetail';
import GroupButton from 'kts-platform-frame/display/components/GroupButton';
import Urls from 'kts-platform-frame/entry/constant/Urls';
import { InvoiceImport } from 'kts-platform-frame/display/part';
import CreatGroup from './UI.CreatGroup';
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import { InvoiceState, NotionalPoolingState } from './StateEnum';
import ModulesState from './Modules.State';
import JSObject from 'kts-scaffold-framework/utils/kit/JSObject';
import { withRouter } from 'kts-platform-frame/routes';
import UIInvoiceModal from './UI.InvoiceModal';

const css = require('./index.scss');

const INIT_NUM = 20;


/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    fresh?: string;
    refreshCount?: (value: number) => void;
}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect

@connect((state: ReduxState): IReduxStatePart => ({

}))
class UserForm extends UIBasic<IProps, ModulesState> {

    private columns = [
        {
            title: '',
            dataIndex: 'pId',
            width: 33,
            className: `text-center ${css['invoice-card-thspecial']}`,
            render: (text) => {
                return (
                    <span>
                        {text && <Icon type="zicengji" style={{ fontSize: 9, color: '#999999' }} />}
                    </span>
                );
            }
        },
        {
            title: '',
            dataIndex: 'index',
            width: 100,
            className: `text-center `,
            render: (text, record) => {
                return (
                    <div >
                        {
                            record.recordType === 2 &&
                            <Icon type="wendang" style={{ fontSize: 16, color: '#5CC4E9' }} />

                        }
                        {
                            record.recordType === 1 &&
                            <div className="ui-item-icon input-type bg-green" style={{width:'auto',padding:'0 5px'}}>
                                {typeDescNew(record)}
                            </div>

                        }
                    </div>
                );
            }
        },
        {
            title: '销售方名称',
            dataIndex: 'supplierName',
            className: css['nowrap'],
            render: (text, record) => {
                return (
                    <span>
                        {
                            record.groupNumber ?
                                (<span title={record.groupNumber}>

                                    {
                                        record.createType === 1 ?
                                            <span style={record.matchState === 1 ? {} : { color: '#e60012' }} title='已匹配/已收/应收'>({record.invoiceCount}/{record.loggedCount}/{record.shouldCount})
                                            </span>
                                            : <span title='已收'>&nbsp;({record.loggedCount})</span>
                                    }
                                    &nbsp;{record.groupNumber}
                                </span>)
                                : <span title={text}>{text}</span>
                        }
                    </span>
                );

            }
        },
        {
            title: '',
            dataIndex: 'unusualState',
            width: 49,
            className: 'text-center',
            render: (text, record) => {
                return (
                    <span>
                        {/* {text !== 'NORMAL' && this.creatTip(record)} */}
                        {record.recordType === 1 && this.creatTip(record)}
                        {record.createType === 1 && this.creatIcon(record)}
                    </span>
                );
            }
        },
        {
            title: '发票代码',
            width: 105,
            dataIndex: 'invoiceCode'
        },
        {
            title: '发票号码',
            width: 90,
            dataIndex: 'invoiceNumber'
        },
        {
            title: '开票日期',
            width: 100,
            dataIndex: 'invoiceDate',
            render: (text) => Field.formatDate(text)
        },
        {
            title: '价税合计',
            dataIndex: 'amount',
            width: 90,
            render: (text) => Field.formatMoney(text, 2)
        },
        {
            title: '发票状态',
            width: 90,
            dataIndex: 'invoiceState',
            render: (text) => {
                return (
                    text === 'NORMAL' ? <span>{InvoiceState[text]}</span> : <span style={{color: 'red'}}>{InvoiceState[text]}</span>
                ); 
            }
        },
        {
            title: '提交状态',
            width: 90,
            dataIndex: 'isNotionalPooling',
            render: (text) => {
                return (
                    <span>{NotionalPoolingState[text]}</span>
                );
            }
        },
        {
            title: '录入时间',
            dataIndex: 'loggedDate',
            width: 105,
            render: (text, record) => {
                return (
                    <div>
                        {record.recordType === 1 && text && moment(text).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                );
            }
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            className: 'text-left',
            width: 120,
            render: (text, record) => {
                return (
                    <div>
                        {this.creatBtns(record)}
                    </div>
                );
            }
        }
    ];
    //private ford = window.top.location.href.indexOf('caf') >= 0;
    constructor(props: any) {
        super(props, ModulesAction);
        this.state = {
            list: [],
            pageMeta: {},
            expand: false,
            pageNum: 1,
            pageSize: 20,
            fields: this.modulesState.fields,
            selectedRows: [],
            selectedRowKeys: [],
            message: null,
            show: false,
            template: false,
            templateData: null,
            hasMore: true,
            loading: false,
            refresh: false,
            receiveState: 'PASS',
            expandedRowKeys: [],
            fresh: this.props.fresh,
            visible: false,
            haveGroup: 0,
            autoSubmit: true,
            allGroup: false,
            groupvisible: false,
            retryVisible: false, 
        };
    }
    creatBtns = (record) => {
        if (!record) {
            return '';
        }
        let buttons: any = [];
        if (record.realCheckState === 'PASS' || record.recordType === 2) {
            buttons.push({ title: '详情', onClick: () => { this.onDetail(record); } });
        }

        if (record.recordType === 1 && record.realCheckState === 'PASS') {
            buttons.push({ title: '票面', onClick: () => { this.onShowTemplate(record); } });
        }
        if (record.isUploadFile === 1) {
            buttons.push({ title: '影像', onClick: () => { this.viewFailedImage(record); } });
        }
        if (record.recordType === 2) {
            buttons.push({ title: <Popconfirm title="确认删除" onConfirm={() => this.onDelete(record)} > <span className="hand">删除</span> </Popconfirm> });
        }
        if (record.children || record.recordType === 1) {
            buttons.push({ title: '附加', onClick: () => { this.onShowInvoiceDetail(record); } });
        }
        if (record.recordType === 1) {
            buttons.push({ title: record.receiveState === 'PASS' ? '拒绝' : '接受', onClick: () => { this.onRefused(record); } });
        } else {
            if (record.children) {
                buttons.push({ title: this.state.receiveState === 'PASS' ? '拒绝' : '接受', onClick: () => { this.onGroupRefuse(record); } });
            }
        }
        if (record.realCheckState === 'FAILED') {
            buttons.push({ title: '重验', onClick: () => { this.onGetInvoice(record); } });
        }
        return <GroupButton buttons={buttons} />;
    }
    onRefresh = () => {
        this.refreshInvoice();

    }
    onAddGroup = () => {
        this.setState({
            addModal: true
        });
    }

    onShowInvoicePanel = () => {
        const urlData = {
            key3: Urls.logInvoiceMANUAL,
            scankey4: Urls.logInvoiceSCANNER_GUN,
            qrtoken: Urls.group_getUploadToken,
            downloadurl: Urls.group_downloadTemplate,
            url: Urls.group_uploadFile,
            scanerurl: Urls.group_ocrtoken,
            show: true
        };
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={this.onRefresh} />,
            title: '发票录入'
        });
    }
    onCloseModal = () => {
        this.setState({
            addModal: false
        });
    }
    //重新验证发票-
    onGetInvoice = record => {
        invoiceInput.realcheckQuery(this, { loggingBizId: record.invoiceEntryId }).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    message.success('更新成功');
                }
            }
        });
    }
    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    handleOk = (e) => {
        this.onCollect();
        this.setState({
            visible: false,
        });
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    viewFailedImage = record => {
        invoiceInput.ImgQuery(this, { invoiceLoggingId: record.invoiceEntryId }).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    window.open(res.originFileUrl);
                }
            }
        });
    }
    creatTip = (record) => {
        // duplicateState = 'FAILED' 重复录入, PASS 非重复录入

        let warnArray = [];
        let color = '#72b148';
        let icontype = 'anticon-zhengque'; // 正确 
        if (record.decodeState === 'RECOGNITION') {
            icontype = 'anticon-icon-test'; // 漏斗
            color = '#BCC7D3';
            warnArray.push(<div key="9">识别中</div>);
        }
        if (record.realCheckState === 'CHECKING') {
            icontype = 'anticon-icon-test'; // 漏斗
            color = '#BCC7D3';
            warnArray.push(<div key="10">查验中</div>);
        }

        // 异常
        if (record.unusualState === 'UNUSUAL' || record.unusualState === 'WARN') {
            if (record.unusualState === 'UNUSUAL') {
                color = '#f5222d';
                icontype = 'anticon-fapiaoyichang'; // 异常
            } else if (record.unusualState === 'WARN') {
                icontype = 'anticon-fapiaoyichang'; // 异常warning
                color = '#faad14';
            }
            if (record.decodeState === 'FAILED') {
                warnArray.push(<div key="0">未识别</div>);
            }
            if (record.duplicateState === 'FAILED') {
                warnArray.push(<div key="1">重复录入</div>);
            }
            if (record.realCheckState === 'FAILED') {
                warnArray.push(<div key="2">查验失败:{record.realCheckMsg || '查验异常'}</div>);
                if (record.wrongVat === "1") {
                    warnArray.push(<div key="12">错票:{record.wrongVatMsg || '发票异常'}</div>);
                }
            }
            if (record.standardState === 'FAILED') {
                warnArray.push(<div key="3">不合规:{record.standardMsg}</div>);
            }
            if (record.standardWarnState === 'FAILED') {
                warnArray.push(<div key="4">提示:{record.standardWarnMsg}</div>);
            }
            if (record.invoiceType === 'UNKOWN_INVOICE_TYPE' || record.invoiceType === null) {
                warnArray.push(<div key="5">未识别</div>);
            }
        } else {
            if (record.realCheckState === 'PASS') {
                warnArray.push(<div key="6">验真通过</div>); // :{record.realCheckMsg || ''}
            }
            if (record.duplicateState === 'PASS') {
                warnArray.push(<div key="7">非重复录入</div>);
            }
            if (record.standardState === 'PASS') {
                warnArray.push(<div key="8">合规</div>); // :{record.standardMsg}
            }
        }
        const warnMessage = <div>{warnArray}</div>;
        if (warnArray.length > 0) {
            return (
                <Tooltip title={warnMessage}>
                    <i className={`anticon ${icontype} ${css.mAnticon}`} style={{ color: color }} />
                </Tooltip>
            );
        } else {
            return <i className={`anticon ${icontype} ${css.mAnticon}`} style={{ color: color }} />;
        }
    }
    creatIcon = (record) => {
        let icontype = 'anticon-zhengque'; // 正确 
        let color = '#72b148';
        if (record.matchState === 1) {

        } else {
            icontype = 'anticon-icon-test'; // 漏斗
            color = '#BCC7D3';
        }
        return <i className={`anticon ${icontype} ${css.mAnticon}`} style={{ color: color }} />;
    }
    onDelete = (record) => {
        invoiceInput.DeleteGroup(this, { invoiceGroupId: record.invoiceGroupId }).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.refreshInvoice();
                }
            }
        });
    }
    clearFields = () => {
        this.setState({
            fields: {}
        });
        this.modulesState.fields = {};
        ModulesAction.setModulesState();
    }
    onAddToGroup = () => {
        if (this.state.selectedRows.length === 0) {
            message.warn('没有勾选发票');
            return null;
        }
        this.setState({
            addToModal: true,
        });
    }
    onCloseSwitch = () => {
        this.setState({
            addToModal: false
        });
    }
    onShowTemplate = (record) => {
        invoiceInput.querySingleDetail(this, { invoiceEntryId: record.invoiceEntryId }).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                if (res) {
                    this.setState({
                        template: true,
                        templateData: res.invoiceDetail,
                        templateType: record.invoiceType
                    });
                }
            }
        });
    }
    closeTemplate = () => {
        this.setState({
            template: false
        });
    }
    onDetail = (record) => {
        if (record.recordType === 2) {
            this.props.history.push(`invoiceInput/group/${record.invoiceGroupId}`);
        } else {
            this.props.history.push(`invoiceInput/invoiceDetail/${record.invoiceEntryId}`);
        }
    }
    handleFormChange = (changedFields) => {
        this.setState({
            fields: { ...this.state.fields, ...changedFields },
        });
    }
    refreshInvoice = () => {
        this.setState({
            list: [],
            selectedRows: [],
            selectedRowKeys: [],
            pageNum: 1,
            pageSize: 20,
            hasMore: true,
            loading: false
        }, () => { this.getData(); });

    }
    clearRows = () => {
        this.setState({
            list: [],
            selectedRows: [],
            selectedRowKeys: [],
            pageNum: 1,
            pageSize: 20,
        });
    }
    componentDidMount() {
        this.getData();
        this.checkAutoBtn();
        this.checkAllGroup(); 
    }
    //是否整组提交发票组
    checkAllGroup = () => {
        invoiceInput.submitAllGroup(this, {}).then((response: any) => {
            const res = response.res;
            if (res) {
                this.setState({
                    allGroup: res
                });
            }
        });
    }
    //检查是否显示提交按钮
    checkAutoBtn = () => {
        invoiceInput.autoSubmitBtn(this, {}).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                this.setState({
                    autoSubmit: !!res
                });

            }

        });
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.location.state) {
            if (nextProps.location.state.refresh && !this.state.refresh) {
                this.setState({
                    refresh: true,
                    list: [],
                    selectedRows: [],
                    selectedRowKeys: [],
                    pageNum: 1,
                    pageSize: 20,
                    hasMore: true,
                    loading: false
                }, () => { this.getData(); });
                //this.getData();
            }
        }
        if (nextProps.fresh !== this.state.fresh) {
            this.setState({
                fresh: nextProps.fresh
            }, () => { this.refreshInvoice(); });
        }

    }
    onSwitchHandler = (values) => {
        let { selectedRows } = this.state;
        selectedRows = selectedRows.filter((item) => item.recordType === 1);
        const data = selectedRows.map((item) => {
            return {
                invoiceCode: item.invoiceCode,
                invoiceNumber: item.invoiceNumber,
                loggingId: item.invoiceEntryId
            };
        });
        const dataConstruct: any = {
            groupNumber: values.groupNumber,
            list: data
        };
        invoiceInput.MoveGroup(this, dataConstruct).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                if (res) {
                    const insert = res.map((item, index) => {
                        if (!item.success) {
                            return <div key={index}>发票代码:{item.invoiceCode},发票号码:{item.invoiceNumber} {item.message}</div>;
                        }
                        return <div key={index}>发票代码:{item.invoiceCode},发票号码:{item.invoiceNumber} {item.message}</div>;
                    });
                    this.setState({
                        message: insert,
                        show: true,
                        pageNum: 1,
                        pageSize: 20,
                        list: [],
                        selectedRows: [],
                        selectedRowKeys: []
                    }, () => { this.refreshInvoice(); });

                }

            }
        });
    }
    public onShowInvoiceDetail = (record) => {
        let option: any = {};
        if (record && record.recordType === 1) {
            option.type = 1;
            option.entryIds = [{
                entryId: record.invoiceEntryId,
                groupId: record.invoiceGroupId,
                type: record.recordType
            }];
        } else if (record && record.recordType === 2) {
            option.entryIds = [{
                entryId: record.invoiceEntryId,
                groupId: record.invoiceGroupId,
                type: record.recordType
            }];
        } else {
            let entryIds = [];
            let { selectedRows } = this.state;
            selectedRows = selectedRows.filter((item) => item.recordType === 1);
            for (let i = 0; i < selectedRows.length; i++) {
                entryIds.push({
                    entryId: selectedRows[i].invoiceEntryId,
                    groupId: selectedRows[i].invoiceGroupId,
                    type: selectedRows[i].recordType
                });
            }
            if (entryIds.length === 1) {
                option.type = 1;
            }
            option.entryIds = entryIds;
        }
        MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
            Components: <InvoiceDetail type={option.type} entryIds={option.entryIds} />,
            title: '附加信息'
        });
    }
    onCollect = () => {
        invoiceInput.InvoiceCollect(this).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {
                message.success('操作成功');
            }
        });
    }
    addAlert = () => {
        return (
            <Alert
                message={this.state.message}
                type="warning"
                closable={true}
                className="mb10"
                style={{ height: 70, overflowY: 'scroll' }}
                onClose={() => { this.setState({ show: false }); }}
            />
        );
    }
    toggle = () => {
        let { fields } = this.state;
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <AdvancedForm
                clearFields={this.clearFields}
                fields={fields}
                onValuesChange={this.handleFormChange}
                getData={this.refreshInvoice}
            />,
            title: '筛选'
        });
        // const { expand } = this.state;
        // this.setState({ expand: !expand });
    }
    handleInfiniteOnLoad = async () => {
        if (this.state.hasMore) {
            this.setState({
                loading: true,
            });
            const { pageMeta } = this.state;

            if (pageMeta.pageSize * pageMeta.pageNum < pageMeta.total) {
                this.setState({
                    pageNum: this.state.pageNum + 1
                }, () => { this.getData(); });
            }
        }
    }
    handleTagToSearch = (tag) => {
        this.setState({
            receiveState: tag
        }, () => { this.refreshInvoice(); });
    }
    handleTagToGroup = (tag) => {
        let _tag = 0;
        if (this.state.haveGroup !== tag) {
            _tag = tag;
        }
        this.setState({
            haveGroup: _tag
        }, () => { this.refreshInvoice(); });
    }
    onChange = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRows: selectedRows,
            selectedRowKeys: selectedRowKeys,
        });
    }
    onExpand = (expanded, record) => {
        const expandedRowKeys = [...this.state.expandedRowKeys];
        if (!expanded) {
            expandedRowKeys.splice(expandedRowKeys.indexOf(record.index), 1);
        } else {
            expandedRowKeys.push(record.index);
        }
        this.setState({ expandedRowKeys });
    }
    onSelect = (record, selected, selectedRows) => {
        //选择父节点操作
        if (record.recordType === 2 && record.children && record.children.length > 0) {
            if (selected) {
                const { children } = record;
                let keys = [record.index];
                for (let i = 0; i < children.length; i++) {
                    keys.push(children[i].index);
                }
                selectedRows = selectedRows.concat(children);
                keys = keys.concat(this.state.selectedRowKeys);
                const uniqueKeys = Array.from(new Set(keys));
                this.setState({
                    selectedRowKeys: uniqueKeys,
                    selectedRows
                });
            } else {
                const { children } = record;
                let { selectedRowKeys } = this.state;
                let Rows = this.state.selectedRows;
                for (let i = 0; i < children.length; i++) {
                    if (selectedRowKeys.indexOf(children[i].index) >= 0) {
                        selectedRowKeys.splice(selectedRowKeys.indexOf(children[i].index), 1);
                        Rows.splice(Rows.indexOf(children[i].index), 1);
                    }
                }
                if (selectedRowKeys.indexOf(record.index) >= 0) {
                    selectedRowKeys.splice(selectedRowKeys.indexOf(record.index), 1);
                    Rows.splice(Rows.indexOf(record.index), 1);
                }
                this.setState({
                    selectedRowKeys,
                    selectedRows: Rows
                });
            }
            //选择子节点操作
        } else if (record.recordType === 1 && record.invoiceGroupId) {
            const id = record.invoiceGroupId;
            const { list } = this.state;
            let parentRow: any = {};
            let deleteRowKeys = [record.index];
            for (let i = 0; i < list.length; i++) {
                if (id === list[i].id) {
                    parentRow = list[i];
                    deleteRowKeys.push(list[i].index);
                    continue;
                }
            }
            //勾选子节点
            if (selected) {
                let childrenKeys = [];//当前小组的所有子节点keys
                let selectedKeys: any = [];//当前被选中的keys
                if (parentRow.children) {
                    for (let i = 0; i < parentRow.children.length; i++) {
                        childrenKeys.push(parentRow.children[i].index);
                    }
                    for (let i = 0; i < selectedRows.length; i++) {
                        selectedKeys.push(selectedRows[i].index);
                    }
                    let allSelected = childrenKeys.every((item) => selectedKeys.includes(item));
                    if (allSelected) {
                        selectedKeys.push(parentRow.index);
                        selectedRows.push(parentRow);
                        this.setState({
                            selectedRowKeys: selectedKeys,
                            selectedRows
                        });
                    }
                }
            } else {
                //取消子节点
                let { selectedRowKeys } = this.state;
                for (let i = 0; i < selectedRows.length; i++) {
                    if (parentRow.index === selectedRows[i].index) {
                        selectedRows.splice(i, 1);
                    }
                }
                for (let i = 0; i < deleteRowKeys.length; i++) {
                    if (selectedRowKeys.indexOf(deleteRowKeys[i]) >= 0) {
                        selectedRowKeys.splice(selectedRowKeys.indexOf(deleteRowKeys[i]), 1);
                    }
                }
                this.setState({
                    selectedRowKeys,
                    selectedRows
                });
            }
        }
    }
    onGroupRefuse = (record) => {
        let option: any = {};
        option.receiveState = this.state.receiveState === 'PASS' ? 'FAILED' : 'PASS';
        option.groupId = record.invoiceGroupId;
        invoiceInput.InvoiceGroupFinance(this, option).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {
                message.success('操作成功');
                this.refreshInvoice();
            }
        });
    }
    //发票提交（非整组提交） 整组提交：只能提交组id，不能提交组下面的发票。非整组：只能提交发票id，不能提交组id
    onSubmitSwitch = () => {
        if (this.state.allGroup) {

            this.setState({
                groupvisible: true
            });
        } else {
            this.onAutoSubmit();
        }
    }
    handleGroupOK = (e) => {
        this.setState({
            groupvisible: false
        });
        this.onAllGroupSubmit();
    }
    handleGroupCancel = () => {
        this.setState({
            groupvisible: false
        });
    }
    onAllGroupSubmit = () => {
        let option = [];//发票项
        let optionGroups = [];//发票组项
        let { selectedRows } = this.state;
        for (let i = 0; i < selectedRows.length; i++) {
            if (selectedRows[i].recordType === 1) {
                option.push(selectedRows[i]);

            } else if (selectedRows[i].recordType === 2) {
                optionGroups.push(selectedRows[i]);
            }
        }
        //判断发票是在组里面全部被勾选
        for (let i = 0; i < option.length; i++) {
            if (option[i].invoiceGroupId) {
                let isAll = optionGroups.some(item => option[i].invoiceGroupId === item.invoiceGroupId);
                if (!isAll) {
                    message.warn('您的企业设置发票组需整组提交');
                    return false;
                }
            }
        }

        //删除整组里面的发票
        //如果选择了组，那么肯定组下面肯定都被勾选了
        for (let i = 0; i < optionGroups.length; i++) {
            option = option.filter(item => item.invoiceGroupId !== optionGroups[i].invoiceGroupId);
        }
        let entryIdsArray = option.map(item => item.invoiceEntryId);
        let groupIdsArray = optionGroups.map(item => item.invoiceGroupId);
        invoiceInput.loggingAllGroupSubmit(this, { entryIds: entryIdsArray, groupIds: groupIdsArray }).then((response: any) => {
            const res = response.res;

            let insert = '';
            // if (res && res.length > 0) {
            //     insert = res.map((item, index) => {
            //         return <div key={index}>发票代码:{item.invoiceCode},发票号码:{item.invoiceNumber} 不符合提交规则</div>;
            //     });
            // } else if (res && res.length === 0) {
            //     insert = '提交成功';
            // }
            if (res && res.length > 0) {
                insert = res.map((item, index) => {
                    return <div key={index}>发票代码:{item.invoiceCode},发票号码:{item.invoiceNumber} {item.failCause.join()}</div>;
                });
            } else if (res && res.length === 0) {
                insert = '提交成功';
            }
            this.setState({
                message: insert,
                show: true,
                pageNum: 1,
                pageSize: 20,
                list: [],
                selectedRows: [],
                selectedRowKeys: []
            }, () => { this.refreshInvoice(); });

        });

    }
    //非整组提交
    onAutoSubmit = () => {
        let option = [];
        let optionGroups = [];
        let { selectedRows } = this.state;
        for (let i = 0; i < selectedRows.length; i++) {
            if (selectedRows[i].recordType === 1) {
                option.push(selectedRows[i].invoiceEntryId);
            } else if (selectedRows[i].recordType === 2) {
                optionGroups.push(selectedRows[i].invoiceGroupId);
            }
        }
        invoiceInput.loggingSubmit(this, option).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                let insert = '';
                if (res && res.length > 0) {
                    insert = res.map((item, index) => {
                        return <div key={index}>发票代码:{item.invoiceCode},发票号码:{item.invoiceNumber} {item.failCause.join()}</div>;
                    });
                } else if (res && res.length === 0) {
                    insert = '提交成功';
                }
                this.setState({
                    message: insert,
                    show: true,
                    pageNum: 1,
                    pageSize: 20,
                    list: [],
                    selectedRows: [],
                    selectedRowKeys: []
                }, () => { this.refreshInvoice(); });
            }
        });
        // if (optionGroups.length > 0) {
        //     invoiceInput.invoiceSubmit(this, optionGroups).then((response: any) => {
        //         const err = response.er;
        //         const res = response.res;
        //         if (err) {
        //             return null;
        //         } else {
        //             message.success('操作成功');
        //         }
        //     });
        // }
    }
    onRefused = (record?) => {
        let option: any = {};
        if (record) {
            option.receiveState = record.receiveState === 'PASS' ? 'FAILED' : 'PASS';
            option.invoiceEntryIds = [record.invoiceEntryId];

        } else {
            let { selectedRows, receiveState } = this.state;
            option.receiveState = receiveState === 'PASS' ? 'FAILED' : 'PASS';
            let invoiceEntryIds = [];
            selectedRows = selectedRows.filter((item) => item.recordType === 1);
            for (let i = 0; i < selectedRows.length; i++) {
                invoiceEntryIds.push(selectedRows[i].invoiceEntryId);
            }
            option.invoiceEntryIds = invoiceEntryIds;

        }
        invoiceInput.InvoiceFinance(this, option).then((response: any) => {
            const err = response.er && response.er.body;
            const res = response.res;
            if (err) {
                // message.error(err.status.description);
                this.refreshInvoice();
                return false;
            } else {
                message.success('操作成功');
                this.refreshInvoice();
            }
        });
    }
    handleMenuClick = (e) => {
        if (e.key === '1') {
            this.setState({
                retryVisible: true
            });
        }else if (e.key === '2') { 
            this.modulesState.emailDrawerVisible = true;
            this.setModulesState();
        }
    }
    render() {
        let columns = this.columns;
        let {emailSetVisible} = this.modulesState;
        let { selectedRowKeys, fields, list, expandedRowKeys, loading, retryVisible } = this.state;

        let dataSource = list;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onChange,
            hideDefaultSelections: true,
            onSelect: this.onSelect
        };
        const menu = (
            <Menu onClick={this.handleMenuClick}>
                <Menu.Item key="1">批量重试</Menu.Item>
                <Menu.Item key="2">收票邮箱设置</Menu.Item>
            </Menu>
        );
        const { match, location } = this.props;
        const hasSelected = selectedRowKeys.length > 0 && !loading;
        return (
            <div style={{ display: match.url === location.pathname ? '' : 'none' }} >
                <Row className={`${css['invoice-card-hander']}`}>
                    <Col span={11} className="text-left">
                        <Button
                            className={`mr10 font10 ${css['invoice-input-button']} ${css['invoice-card-button']}`}
                            onClick={this.onShowInvoicePanel}
                        >
                            发票录入
                        </Button>
                        <Button
                            className={`mr10 font10 ${css['invoice-card-button']} hide`}
                            onClick={this.onAddGroup}
                        >
                            新增发票组
                        </Button>
                        <Button
                            className={`mr10 font10 ${css['invoice-card-button']}`}
                            onClick={this.onAddToGroup}
                            disabled={this.state.receiveState === 'FAILED' || !hasSelected}
                        >
                            添加到发票组
                        </Button>
                        <Button
                            className={`mr10 font10 ${css['invoice-card-button']}`}
                            onClick={this.onShowInvoiceDetail}
                            disabled={!hasSelected}
                        >
                            更新附加信息
                        </Button>
                        <Button
                            className={`mr10 font10 ${css['invoice-card-button']}`}
                            disabled={!hasSelected}
                            onClick={() => { this.onRefused(); }}
                        >
                            {this.state.receiveState === 'PASS' ? '拒绝' : '接受'}
                        </Button>
                        {/* {this.ford &&
                            <Button
                                className={`mr10 font10 ${css['invoice-card-button']}`}
                                onClick={this.showModal}
                            >
                                发票归集
                            </Button>
                        } */}
                        {
                            !this.state.autoSubmit &&
                            <Button
                                className={`mr10 font10 ${css['invoice-card-button']}`}
                                disabled={!hasSelected}
                                onClick={this.onSubmitSwitch}
                            >
                                提交
                            </Button>
                        }
                        <Dropdown overlay={menu}>
                            <Button>
                                更多 <Icon type="down" />
                            </Button>
                        </Dropdown>
                    </Col>
                    <Col span={13} className="text-right">
                        <div>
                            <span className="mr10">接收状态</span>
                            <span onClick={() => { this.handleTagToSearch('PASS'); }}>
                                <Tag
                                    className={
                                        (this.state.receiveState === 'PASS'
                                            ? 'ant-tag-checkable-checked '
                                            : '') + css['radius13']
                                    }
                                >
                                    已接受
                                </Tag>
                            </span>
                            <span onClick={() => { this.handleTagToSearch('FAILED'); }}>
                                <Tag
                                    className={
                                        (this.state.receiveState === 'FAILED'
                                            ? 'ant-tag-checkable-checked '
                                            : '') + css['radius13']
                                    }
                                    style={{ marginRight: 0 }}
                                >
                                    已拒绝
                                </Tag>
                            </span>
                            <Divider type="vertical" />
                            <span className="mr10">分组状态</span>
                            <span style={{ display: 'none' }} onClick={() => { this.handleTagToGroup(0); }}>
                                <Tag
                                    className={
                                        (this.state.haveGroup === 0
                                            ? 'ant-tag-checkable-checked '
                                            : '') + css['radius13']
                                    }
                                >
                                    全部
                                </Tag>
                            </span>
                            <span onClick={() => { this.handleTagToGroup(1); }}>
                                <Tag
                                    className={
                                        (this.state.haveGroup === 1
                                            ? 'ant-tag-checkable-checked '
                                            : '') + css['radius13']
                                    }
                                >
                                    有分组
                                </Tag>
                            </span>
                            <span onClick={() => { this.handleTagToGroup(2); }}>
                                <Tag
                                    className={
                                        (this.state.haveGroup === 2
                                            ? 'ant-tag-checkable-checked '
                                            : '') + css['radius13']
                                    }
                                >
                                    无分组
                                </Tag>
                            </span>

                            <Button
                                onClick={this.toggle}
                                className={`mr10 mb-10 font10 ${css['invoice-card-button']}`}
                                htmlType="submit"
                                icon="shaixuan font13"
                            >
                                筛选
                            </Button>
                            <Button
                                // icon="shuaxin font13"
                                icon="sync"
                                className={`mr10 font10 ${css['invoice-card-button']}`}
                                onClick={this.onRefresh}
                            >
                            </Button>
                        </div>
                    </Col>
                </Row>
                {/* <div style={{ display: this.state.expand ? 'block' : 'none' }}>
                    <AdvancedForm
                        clearFields={this.clearFields}
                        fields={fields}
                        onValuesChange={this.handleFormChange}
                        getData={this.refreshInvoice}
                    />
                </div> */}
                {
                    this.state.show && this.addAlert()
                }
                {
                    retryVisible &&
                    <Modal visible={retryVisible} title="批量发票查验重试" onCancel={this.onCloseRetry} footer={null}>
                        <RetryForm onClose={this.onCloseRetry} refreshData={this.getData} />
                    </Modal>
                }
                {this.modulesState.emailDrawerVisible && <UIEmail />}
                {emailSetVisible && <UIEmailSet />}
                <Modal
                    title="提示"
                    visible={this.state.groupvisible}
                    onOk={this.handleGroupOK}
                    onCancel={this.handleGroupCancel}
                >
                    <p>确认提交已勾选的发票和发票组？</p>
                </Modal>
                <div style={{ height: (this.state.expand ? 'calc(100Vh - 345px)' : 'calc(100Vh - 150px)'), overflow: 'auto' }}>
                    <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={this.handleInfiniteOnLoad}
                        hasMore={!this.state.loading && this.state.hasMore}
                        loader={<div style={{ textAlign: 'center' }} key={0}><Spin></Spin> 数据加载中</div>}
                        useWindow={false}
                    >
                        <Table
                            className="ui-list"
                            style={{ borderColor: '#E9EAEB' }}
                            bordered={true}
                            dataSource={dataSource}
                            indentSize={0}
                            columns={columns}
                            rowClassName={(record, index) => {
                                if (record.recordType === 2 && this.state.receiveState === 'FAILED') {
                                    if (!record.children) {
                                        return 'hide';
                                    } else {
                                        return 'groupItem';
                                    }
                                } else {
                                    return 'ui-item doc-item';
                                }
                            }}
                            rowKey="index"
                            rowSelection={rowSelection}
                            defaultExpandAllRows={true}
                            pagination={false}
                            scroll={{ x: 1000 }}
                        />
                        <div className="text-center" style={{ paddingTop: 10 }}>
                            {
                                this.state.hasMore ? <Button onClick={this.handleInfiniteOnLoad}>加载更多</Button> : <p>没有更多了</p>
                            }
                        </div>
                    </InfiniteScroll>
                </div>

                {
                    this.state.addToModal &&
                    <SwitchGroup onCloseModal={this.onCloseSwitch} onSwitchHandler={this.onSwitchHandler} rows={this.state.selectedRows} />
                }
                {/* {
                    this.state.template &&
                    Template({ type: this.state.templateType, data: this.state.templateData, onClose: this.closeTemplate })
                } */}
                {
                    this.state.template &&
                    <UIInvoiceModal
                        template={this.state.template}
                        templateType={this.state.templateType}
                        templateData={this.state.templateData}
                        closeTemplate={this.closeTemplate}
                    />
                }
                {
                    this.state.addModal &&
                    <CreatGroup onCloseModal={this.onCloseModal} onFresh={this.onRefresh} />
                }
                <Modal
                    title="归集"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <p>你确定要归集吗？</p>
                </Modal>
            </div >
        );
    }
    onCloseRetry = () => {
        this.setState({
            retryVisible: false
        });
    }
    clearData = () => {
        this.setState({
            list: [],
            pageNum: 1,
            hasMore: true,
            loading: false
        }, () => { this.getData(); });

    }
    getData = async () => {
        let { fields, pageNum, pageSize, expandedRowKeys, receiveState, haveGroup } = this.state;
        fields = { ...fields, pageNum, pageSize, receiveState, haveGroup };
        this.modulesState.fields = { ...fields };
        ModulesAction.setModulesState();
        fields = {
            ...fields,
            minInvoiceDate:
                fields['minInvoiceDate'] &&
                fields['minInvoiceDate'].format('YYYY-MM-DD'),
            maxInvoiceDate:
                fields['maxInvoiceDate'] &&
                fields['maxInvoiceDate'].format('YYYY-MM-DD'),
            minLoggedDate:
                fields['minLoggedDate'] &&
                fields['minLoggedDate'].format('YYYY-MM-DD HH:mm:ss'),
            maxLoggedDate:
                fields['maxLoggedDate'] &&
                fields['maxLoggedDate'].format('YYYY-MM-DD HH:mm:ss')
        };
        fields = JSObject.getClearBlankParas(fields);
        fields = JSObject.clearBlankArray(fields);
        let list = this.state.list;
        const data = await ModulesAction.getGroupData(fields);
        if (data) {
            const treeData = list.concat(data.items);
            //console.log(treeData);
            if (data.pageMeta.pageNum * data.pageMeta.pageSize >= data.pageMeta.total) {
                console.log('没有更多了');
                this.setState({
                    hasMore: false
                });
            }
            this.setState({
                list: treeData,
                pageMeta: data.pageMeta,
                loading: false,
                refresh: false
            });
            this.props.refreshCount(data.pageMeta.total);
        }
    }
}
export default UserForm;



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/TableList.tsx